

class ConventionModuleLogic {
  identificationEventModule; 
  appContext;
  framework;

  constructor(_identificationEventModule,_appContext,_framework) {
    this.identificationEventModule = _identificationEventModule;
    this.appContext = _appContext;
    this.framework = _framework;
  }


  async fetchConventionArray(_successCallback,_errorCallback) {
    let appError = null;
    const condition = "where status_id='ACT'";
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().fetchConventionArray(condition,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        let json = response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  } 

  async addConvention(_convention,_successCallback,_errorCallback) {
    let appError = null;
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().addConvention(_convention,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        let json =  response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  }      

  async editConvention(_convention,_successCallback,_errorCallback) {
    let appError = null;
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().editConvention(_convention,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        let json =  response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  }

  async removeConvention(_convention,_successCallback,_errorCallback) {
    let appError = null;
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().removeConvention(_convention,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        let json = response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  } 
  

  async fetchConferenceArray(_successCallback,_errorCallback) {
    let appError = null;
    const condition = "where status_id='ACT'";
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().fetchConferenceArray(condition,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        let json = response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  } 

  async addConference(_conference,_successCallback,_errorCallback) {
    let appError = null;
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().addConference(_conference,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        let json =  response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  }      

  async editConference(_conference,_successCallback,_errorCallback) {
    let appError = null;
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().editConference(_conference,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        let json =  response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  }

  async removeConference(_conference,_successCallback,_errorCallback) {
    let appError = null;
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().removeConference(_conference,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        let json = response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  }


  async fetchExpositorArray(_successCallback,_errorCallback) {
    let appError = null;
    const condition = "where status_id='ACT'";
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().fetchExpositorArray(condition,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        let json = response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  } 

  async addExpositor(_expositor,_successCallback,_errorCallback) {
    let appError = null;
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().addExpositor(_expositor,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        let json =  response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  }      

  async editExpositor(_expositor,_successCallback,_errorCallback) {
    let appError = null;
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().editExpositor(_expositor,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        let json =  response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  }

  async removeExpositor(_expositor,_successCallback,_errorCallback) {
    let appError = null;
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().removeExpositor(_expositor,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        let json = response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  }  
  

  async fetchConventionGuestArray(_successCallback,_errorCallback) {
    let appError = null;
    const condition = "where status_id='ACT'";
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().fetchConventionGuestArray(condition,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        let json = response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  }

  async fetchConventionGuestArrayWithCondition(_condition,_successCallback,_errorCallback) {
    let appError = null;
    const condition = _condition;
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().fetchConventionGuestArray(condition,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        let json = response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  }  

  async createConventionGuest(createConventionGuestRequest,_successCallback,_errorCallback) {
    console.log("createConventionGuest");
    console.log(createConventionGuestRequest);
    let appError = null;
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().createConventionGuest(createConventionGuestRequest,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        console.log(response);
        let json = response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  }

 
  async activateConventionGuest(activateConventionGuestRequest,_successCallback,_errorCallback) {
    let appError = null;
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().activateConventionGuest(activateConventionGuestRequest,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        console.log(response);
        let json = response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  }
  
}


export default ConventionModuleLogic;